import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { MetronicI18nProvider } from './shared/i18n/Metronici18n';
import './shared/assets/sass/main.scss';
import 'animate.css';
import { persistor, store } from './store';
import { AppRoutes } from './app/routing/AppRoutes';
import { ThemeModeProvider } from './shared/partials/layout/theme-mode/ThemeModeProvider';
import { PersistGate } from 'redux-persist/integration/react';
import setupAxios from './app/utils/setupAxios';

// Magic-link handling: persist the sessionToken from the URL, then strip the
// query so React boots with a clean URL. forceLogin clearing happens in ./store,
// before redux-persist rehydrates.
const _params = new URLSearchParams(window.location.search);
const _sessionToken = _params.get('sessionToken');

if (_sessionToken) {
  try {
    localStorage.setItem('auth.sessionToken', _sessionToken);
    localStorage.setItem('auth.sessionTokenTimestamp', String(Date.now()));
  } catch {
    // Safari private browsing or storage quota exceeded
  }
  window.history.replaceState({}, '', window.location.pathname);
}

const container = document.getElementById('root');

setupAxios(store);

if (container) {
  createRoot(container).render(
    <React.StrictMode>
      <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
          <MetronicI18nProvider>
            <ThemeModeProvider>
              <AppRoutes />
            </ThemeModeProvider>
          </MetronicI18nProvider>
        </PersistGate>
      </Provider>
    </React.StrictMode>,
  );
}
